export default types => ({
  get: params => ({ type: types.GET, payload: params }),
  reset: () => ({ type: types.RESET }),
  cancel: () => ({ type: types.CANCEL }),
  failed: payload => ({ type: types.FAILED, payload }),
  success: payload => ({ type: types.SUCCESS, payload })
});
